import React from 'react'
import { usePermissions, isPermissionsLoaded } from '@/lib/usePermissions'

interface Props {
  resource: string
  action?: string
  children: React.ReactNode
}

export function PermissionGate({ resource, action = 'view', children }: Props) {
  const { can } = usePermissions()

  if (!isPermissionsLoaded()) return null

  if (!can(resource, action)) {
    return (
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '60vh',
        gap: '12px',
        color: 'var(--text-muted)',
        fontFamily: 'var(--font-sans)',
      }}>
        <div style={{ fontSize: '48px', lineHeight: 1 }}>403</div>
        <div style={{ fontSize: '16px', fontWeight: 600, color: 'var(--text-primary)' }}>Access Denied</div>
        <div style={{ fontSize: '14px', textAlign: 'center', maxWidth: '320px' }}>
          You don't have permission to view this page. Contact your administrator to request access.
        </div>
      </div>
    )
  }

  return <>{children}</>
}
